document.addEventListener('DOMContentLoaded', function () {
  function initNewsletter() {
    const newsletterForm = document.querySelector('.newsletter-form');
    const newsletterModal = document.getElementById('newsletter-modal');
    const overlay = document.getElementById('overlay');
    const closeBtn = document.getElementById('closeBtn');
    const shopButton = newsletterModal?.querySelector('.shop-button');

    if (newsletterModal) {
      newsletterModal.style.display = 'none';
    }
    if (overlay) {
      overlay.style.display = 'none';
    }

    function openModal() {
      if (newsletterModal) {
        newsletterModal.style.display = 'block';
        newsletterModal.classList.add('is-visible');
      }
      if (overlay) {
        overlay.style.display = 'block';
        overlay.classList.add('is-visible');
      }
      document.body.style.overflow = 'hidden';
    }

    function closeModal() {
      if (newsletterModal) {
        newsletterModal.style.display = 'none';
        newsletterModal.classList.remove('is-visible');
      }
      if (overlay) {
        overlay.style.display = 'none';
        overlay.classList.remove('is-visible');
      }
      document.body.style.overflow = 'auto';

      const currentUrl = new URL(window.location.href);
      currentUrl.searchParams.delete('customer_posted');
      currentUrl.hash = '';

      window.history.replaceState({}, document.title, currentUrl.toString());
    }

    if (newsletterForm) {
      newsletterForm.addEventListener('submit', function (event) {
        event.preventDefault();

        if (!newsletterForm.checkValidity()) {
          newsletterForm.reportValidity();
          return;
        }

        newsletterForm.submit();
      });
    }

    closeBtn?.addEventListener('click', closeModal);
    shopButton?.addEventListener('click', closeModal);

    overlay?.addEventListener('click', closeModal);

    const currentUrl = window.location.href;
    if (currentUrl.includes('customer_posted=true#contact_form')) {
      openModal();
    }
  }

  initNewsletter();
});